import initialState from './../../initialState';

export default (state = initialState.consumo, { type, value, response }) => {
  var detalhe;

  switch (type) {
    case 'LIST_SOLICITACOES_AGUA_MINERAL_COMPETENCIA_SUCCESS':
      return {
        ...state,
        competencias: {
          ...state.competencias,
          ...response,
          fetching: 2
        }
      };
    case 'LIST_DETALHE_SOLICITACOES_AGUA_MINERAL_COMPETENCIA_SUCCESS':
      detalhe = state.competencias.result.find(v => v === value);
      detalhe.detail = {
        ...detalhe.detail,
        ...response,
        fetching: 2
      };
      return {
        ...state,
        competencias: {
          ...state.competencias,
          fetching: 2
        }
      };
    case 'LIST_SOLICITACOES_AGUA_MINERAL_REQUEST':
      return {
        ...state,
        solicitacoes: {
          ...state.solicitacoes,
          ...response,
          fetching: 1
        }
      };
    case 'LIST_SOLICITACOES_AGUA_MINERAL_SUCCESS':
      return {
        ...state,
        solicitacoes: {
          ...state.solicitacoes,
          ...response,
          fetching: 2
        }
      };
    case 'DETAIL_CONSUMO_AGUA_MINERAL_UNIDADES_REQUEST':
      detalhe = state.aguaMineral.result.find(v => v === value);
      detalhe.detail = {
        result: [],
        ...detalhe.detail,
        ...response,
        fetching: 1,
        errors: []
      };
      return {
        ...state,
        aguaMineral: {
          ...state.aguaMineral,
          fetching: 1
        }
      };
    case 'DETAIL_CONSUMO_AGUA_MINERAL_UNIDADES_SUCCESS':
      detalhe = state.aguaMineral.result.find(v => v === value);
      detalhe.detail = {
        ...detalhe.detail,
        ...response,
        fetching: 2
      };
      return {
        ...state,
        aguaMineral: {
          ...state.aguaMineral,
          fetching: 2
        }
      };
    case 'LIST_CONSUMO_AGUA_MINERAL_UNIDADES_REQUEST':
      return {
        ...state,
        aguaMineral: {
          ...state.aguaMineral,
          fetching: 1,
          errors: []
        }
      };
    case 'LIST_CONSUMO_AGUA_MINERAL_UNIDADES_SUCCESS':
      return {
        ...state,
        aguaMineral: {
          ...state.aguaMineral,
          fetching: 2,
          ...response
        }
      };
    case 'LIST_CONSUMO_AGUA_UNIDADES_REQUEST':
      return {
        ...state,
        agua: {
          ...state.agua,
          fetching: 1,
          errors: []
        }
      };
    case 'LIST_CONSUMO_AGUA_UNIDADES_SUCCESS':
      return {
        ...state,
        agua: {
          ...state.agua,
          fetching: 2,
          ...response
        }
      };
    case 'CHANGE_SITUACAO_SOLICITACAO_AGUA_MINERAL_REQUEST':
      detalhe = state.solicitacoes.result.find(v => v.id === value.id);
      if (detalhe) {
        detalhe.fetching = 1;
      }
      return {
        ...state,
        solicitacoes: {
          ...state.solicitacoes
        }
      };
    case 'CHANGE_SITUACAO_SOLICITACAO_AGUA_MINERAL_SUCCESS':
      detalhe = state.solicitacoes.result.find(v => v.id === value.id);
      if (detalhe) {
        detalhe.fetching = 2;
      }
      return {
        ...state,
        solicitacoes: {
          ...state.solicitacoes
        }
      };
    case 'LIST_MARCAS_AGUA_MINERAL_UNIDADES_REQUEST':
      return {
        ...state,
        marcas: {
          ...state.marcas,
          fetching: 1,
          errors: []
        }
      };
    case 'LIST_MARCAS_AGUA_MINERAL_UNIDADES_SUCCESS':
      return {
        ...state,
        marca: (response.result.values && 0 < response.result.values.length?"" + response.result.values[0].id_produto:""),
        marcas: {
          ...state.marcas,
          fetching: 2,
          ...response
        }
      };
    case 'INSERT_CONSUMO_AGUA_MINERAL_UNIDADES_REQUEST':
      return {
        ...state,
        aguaMineral: {
          ...state.aguaMineral,
          fetching: 1
        }
      };
    case 'INSERT_CONSUMO_AGUA_MINERAL_UNIDADES_SUCCESS':
      return {
        ...state,
        marca: value.value
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/consumo/reducer.js